// extracted by mini-css-extract-plugin
module.exports = {"container":"BorderedList-module__container--2Bmt1","rows":"BorderedList-module__rows--3B7YP","row":"BorderedList-module__row--2XLUK"};